import { configureStore } from "@reduxjs/toolkit";
import notificationReducer from "./notifications/reducer";
import userReducer from "./user/reducer";
import locationReducer from "./location/reducer";
import handbooksReducer from "./handbooks/reducer";
import locksReducer from "./locks/reducer";

const rootStore = configureStore({
  reducer: {
    notifications: notificationReducer,
    user: userReducer,
    location: locationReducer,
    handbooks: handbooksReducer,
    locks: locksReducer,
  },
});

export type RootState = ReturnType<typeof rootStore.getState>;
export type AppDispatch = typeof rootStore.dispatch;
export default rootStore;
